import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Switch,
  Box,
  Typography,
  Divider,
  Slide,
} from "@mui/material";
import { CATEGORIES } from "../../utils/cookieConsent";
import { useCookieConsent } from "../../context/CookieConsentContext";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DEFAULT_INTRO_TEXT =
  "We use cookies to run this site, understand how it's used, and show third-party content like Trustpilot reviews. Choose which categories you allow. You can change this anytime from \"Cookie Settings\" in the footer.";

export default function CookiePreferencesDialog() {
  const {
    consent,
    preferencesOpen,
    closePreferences,
    acceptAll,
    rejectAll,
    savePreferences,
  } = useCookieConsent();

  const { webSettings } = useSelector((state) => state.webSettings);
  const cookieSettings = (webSettings && webSettings.cookieConsent) || {};
  const configuredCategories = cookieSettings.categories || [];

  // Admin-configured label/description override the built-in defaults;
  // key/required always come from CATEGORIES, so the actual consent
  // logic (which categories exist, which are locked on) never changes.
  const categories = CATEGORIES.map((cat) => {
    const override = configuredCategories.find((c) => c.key === cat.key);
    return override
      ? {
          ...cat,
          label: override.label || cat.label,
          description: override.description || cat.description,
        }
      : cat;
  });

  const [draft, setDraft] = useState(consent);

  useEffect(() => {
    if (preferencesOpen) setDraft(consent);
  }, [preferencesOpen, consent]);

  const toggleCategory = (key) => {
    setDraft((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Dialog
      open={preferencesOpen}
      onClose={closePreferences}
      TransitionComponent={Transition}
      maxWidth="sm"
      fullWidth
      aria-labelledby="cookie-preferences-title"
    >
      <DialogTitle id="cookie-preferences-title">Cookie Preferences</DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ mb: 2 }}>
          {cookieSettings.dialogIntroText || DEFAULT_INTRO_TEXT}
        </DialogContentText>
        {categories.map((cat, i) => (
          <React.Fragment key={cat.key}>
            {i > 0 && <Divider sx={{ my: 1.5 }} />}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box>
                <Typography variant="subtitle1">{cat.label}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {cat.description}
                </Typography>
              </Box>
              <Switch
                checked={!!draft[cat.key]}
                disabled={cat.required}
                onChange={() => toggleCategory(cat.key)}
                inputProps={{ "aria-label": `${cat.label} cookies` }}
              />
            </Box>
          </React.Fragment>
        ))}
      </DialogContent>
      <DialogActions sx={{ flexWrap: "wrap", justifyContent: "center", gap: 1 }}>
        <Button onClick={rejectAll} color="inherit">
          Reject All
        </Button>
        <Button onClick={acceptAll} color="inherit">
          Accept All
        </Button>
        <Button
          onClick={() => savePreferences(draft)}
          variant="contained"
          color="primary"
        >
          Save Preferences
        </Button>
      </DialogActions>
    </Dialog>
  );
}
